// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"Jl","heading":"Kl","screenReadersOnly":"Ll"};